module.exports = __webpack_public_path__ + "img/RET_1.211741a1.png";